import { makeStack } from './filteredStack'
import { ParserMark, ParserReduceFunction, ParseResult, ParserTag } from './types'

const makeTagStack = () => makeStack<ParserTag>()

type ReduceResult = ParseResult & {
  tagStack: ReturnType<typeof makeTagStack>
}

const makeTag = (start: number, name: string, data?: unknown): ParserTag => {
  const tag: ParserTag = { start, name, length: 0 }
  if (data) {
    tag.data = data
  }
  return tag
}

const inputReducer = (result: ReduceResult, part: string | ParserMark) => {
  if (typeof part === 'string') {
    result.text += part
    return result
  }

  const currentIndex = result.text.length
  if (part.type === 'open') {
    const tag = makeTag(currentIndex, part.name, part.data)
    result.tagStack.push(tag)
  }
  if (part.type === 'close') {
    const tag = result.tagStack.pop((t) => t.name === part.name)
    if (tag) {
      tag.length = currentIndex - tag.start
      result.items.push(tag)
    }
  }
  return result
}

export const reduceMarks: ParserReduceFunction = (input) => {
  const accumulator = { text: '', tagStack: makeTagStack(), items: [] }
  input.reduce(inputReducer, accumulator)
  return { text: accumulator.text, items: accumulator.items }
}
